<template>
  <div class="statusList">
    <!-- 公共title -->
    <Top :name="$t('Unit Status')" :show-button="false"></Top>
    <div class="status-cont">
      <div v-for="(status, index) in statusList" :key="index">
        <div class="status">
          <div class="label">{{ status.label }}</div>
          <div class="value">{{ status.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "status",
  data() {
    return {};
  },
  computed: {
    statusList() {
      return [
        // {
        //   label: this.$t("Total running time of equipment"),
        //   value: "362天20小时"
        // },
        {
          label: this.$t("Last boot time"),
          value: "2022-09-18 13:20:55"
        },
        // {
        //   label: this.$t("Operation/stop of the whole station"),
        //   value: "正常运行"
        // },
        {
          label: this.$t("Screw motor"),
          value: this.$t("Normal operation")
        },
        {
          label: this.$t("Roots pump motor"),
          value: this.$t("Normal operation")
        }
      ];
    }
  },
  mounted() {},
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.statusList {
  height: 100%;
  .status-cont {
    height: 95%;
    overflow: auto;
    font-size: 20px;
  }
  .status {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }
  .label {
    flex: 1;
    margin-right: 10px;
  }
  .value {
    flex: 1;
    font-size: 16px;
    line-height: 24px;
    color: #00e7ff;
  }
}
</style>
